import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

export interface SettingsSectionProps {
  /** Id dell'intestazione, usato da `aria-labelledby`. */
  id: string;
  title: string;
  /** Cosa governa il blocco, in una frase. */
  description: string;
  children: ReactNode;
}

/** Un blocco delle Impostazioni: titolo, testo esplicativo e campi. */
export function SettingsSection({ id, title, description, children }: SettingsSectionProps) {
  return (
    <Paper component="section" variant="outlined" aria-labelledby={id} sx={{ p: 4 }}>
      <Stack spacing={0.5} sx={{ mb: 4 }}>
        <Typography id={id} variant="h6" component="h3">
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </Stack>
      <Stack spacing={4}>{children}</Stack>
    </Paper>
  );
}
